import React from "react";
import { Navigate, Route, RouteProps } from "react-router-dom";
import PrivateRoute from "./privateRoute";


const Login = React.lazy(() => import("../pages/login"));
const Dashboard = React.lazy(() => import("../pages/dashboard"));
const UploadCsv = React.lazy(() => import("../pages/product/uploadcsv"));
const ProductsList = React.lazy(() => import("../pages/product/list"));
const ProductsEdit = React.lazy(() => import("../pages/product/view"));
const ChangePassword = React.lazy(() => import("../pages/change-password"));
const AdminProfileUpdate = React.lazy(() => import("../pages/admins/profile"));
const Comments = React.lazy(() => import("../pages/comments/list"));
const CommentsAdd = React.lazy(() => import("../pages/comments/add"));
const TicketsList = React.lazy(() => import("../pages/tickets/list"));
const AddUser = React.lazy(() => import("../pages/users/add"));

const Error404 = React.lazy(() => import("../pages/errors/error404"));

// dashboards
const dashboardRoute = {
    path: "/dashboard",
    name: "Dashboard",
    icon: "airplay",
    header: "Navigation",
    element: <Dashboard />,
    route: PrivateRoute,
    children: [
      {
        path: "/",
        name: "Root",
        element: <Navigate to="/dashboard" />,
        route: PrivateRoute
      },
      {
        path: "/change-password",
        name: "Root",
        element: <ChangePassword />,
        route: PrivateRoute
      },
      {
        path: "/admin/profile",
        name: "Update Profile",
        element: <AdminProfileUpdate />,
        route: PrivateRoute
      }
    ]
};
const productRoute = {
      path: "/products",
      name: "Buildings",
      element: <ProductsList />,
      route: PrivateRoute,
      children: [
        {
          path: "/products/add",
          name: "Building Add",
          element: <ProductsEdit />,
          route: PrivateRoute
        },
        // {
        //   path: "/products/uploadcsv",
        //   name: "Upload Csv",
        //   element: <UploadCsv />,
        //   route: PrivateRoute
        // },
        {
          path: "/product/view/:id",
          name: "Building View",
          element: <ProductsEdit />,
          route: PrivateRoute
        }
      ]
};
const commentsRoute = {
  path: "/comments/list/:buildingId",
  name: "Comments",
  element: <Comments />,
  route: PrivateRoute,
  children: [
    {
      path: "/comments/add/:buildingId",
      name: "Building Add",
      element: <CommentsAdd />,
      route: PrivateRoute
    },
    {
      path: "/comments/edit/:buildingId/:commentId",
      name: "Building Edit",
      element: <CommentsAdd />,
      route: PrivateRoute
    },
  ]
};

const ticketsRoute = {
  path: "/tickets",
  name: "Tickets",
  element: <TicketsList />,
  route: PrivateRoute,
};

const addUserRoute = {
  path: "/users/add",
  name: "Add User",
  element: <AddUser />,
  route: PrivateRoute,
};

const appRoutes = [
    dashboardRoute,
    productRoute,
    ticketsRoute,
    addUserRoute,
    commentsRoute,
];

// auth
const authRoutes = [
  {
    path: "/login",
    name: "Login",
    element: <Login />,
    route: Route
  },
];
// public routes
const otherPublicRoutes = [
    {
      path: "*",
      name: "Error - 404",
      element: <Error404 />,
      route: Route
    }
  ];

// flatten the list of all nested routes
const flattenRoutes = (routes) => {
  let flatRoutes = [];

  routes = routes || [];
  routes.forEach((item) => {
    flatRoutes.push(item);

    if (typeof item.children !== "undefined") {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

// All routes
const authProtectedRoutes = [
  ...appRoutes,
];
const publicRoutes = [...authRoutes, ...otherPublicRoutes];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);
export {
  publicRoutes,
  authProtectedRoutes,
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
};
